import React from 'react'

const Hero = () => {
  return (
         <section className="hero-bg w-full h-screen flex items-center justify-center text-center text-white">
          <div>
              <h1 className="text-5xl md:text-6xl font-bold mb-4">Joi Jewelry</h1>
              <p className="text-xl md:text-2xl mb-6">Discover our exquisite jewelry collections</p>
              <a href="#gallery" className="bg-purple-400 text-white px-6 py-3 rounded-md hover:bg-purple-700 transition-all duration-100 ease-in" style={{color:"white"}}>Explore Now</a>
          </div>
      </section>
  )
}

export default Hero